import styled from 'styled-components'

import { Box } from '@/atoms/layout'

export const ControlWrapper = styled(Box)`
  white-space: normal;
  overflow-wrap: break-word;
  word-break: break-word;
`
